<template>
  <div>
    <div
      :class="['floating-left ng-float', { 'is-open': showRewardPanel }]"
      style="z-index: 11"
      v-if="pagesToHide.indexOf(this.$route.name) < 0"
      @mouseleave="hoverRewardPanel(false)"
      @focusout="hideShowRewardPanel()"
      tabindex="0"
    >
      <button
        type="button"
        class="floating-button ng-float-tab ng-float-tab--rewards"
        :aria-label="$t(`label.rewards`)"
        :aria-expanded="showRewardPanel ? 'true' : 'false'"
        @click="setShowRewardPanel()"
        @mouseenter="hoverRewardPanel(true)"
      >
        <v-icon class="ng-float-tab-icon" color="#121734">mdi-gift-outline</v-icon>
        <span class="ng-float-tab-label">{{ $t(`label.rewards`) }}</span>
      </button>
      <div v-if="showRewardPanel" class="reward-panel ng-float-panel">
        <div class="ng-float-panel-head">
          <img class="reward-icon" src="/static/svg/gift icons.png" height="44" width="40" alt="" />
          <span class="ng-float-panel-title">{{ $t(`floating.rewardHeader`) }}</span>
          <button type="button" class="ng-float-close" aria-label="Close" @click="hideShowRewardPanel()">
            <v-icon size="18" color="#5B6080">mdi-close</v-icon>
          </button>
        </div>
        <div class="ng-float-tiles">
          <button
            type="button"
            class="ng-float-tile"
            @click="
              hideShowRewardPanel()
              navigateToCoinPage()
            "
          >
            <img :src="`/static/svg/FloatingReward/Deposit-Rewards-${currentLanguage}.jpg`" class="reward-image" height="63" width="206" alt="deposit get free navigate" />
          </button>
          <button
            type="button"
            class="ng-float-tile"
            @click="
              hideShowRewardPanel()
              navigateWOFPage()
            "
          >
            <img class="reward-image" :src="`/static/svg/FloatingReward/Nspin_${currentLanguage}.jpg`" height="63" width="206" alt="fortune spin navigate" />
          </button>
          <button
            type="button"
            class="ng-float-tile"
            @click="
              hideShowRewardPanel()
              navigateToDailyCheckIn()
            "
          >
            <img class="reward-image" :src="`/static/svg/FloatingReward/Check-In-${currentLanguage}.jpg`" height="62" width="206" alt="daily checkin navigate" />
          </button>
          <button
            type="button"
            class="ng-float-tile"
            @click="
              hideShowRewardPanel()
              navigateToVoucherPage()
            "
          >
            <img class="reward-image" :src="`/static/svg/FloatingReward/Claim-Voucher-${currentLanguage}.jpg`" height="62" width="206" alt="claim voucher navigate" />
          </button>
        </div>
      </div>
    </div>
    <v-overlay opacity="0.45" z-index="10" :value="showRewardPanel"></v-overlay>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
import i18n from '@/plugins/i18n'
import { ROUTE_NAME } from '@/constants/route.constants'
import { DevicePlatform } from '@/constants/enums'

export default {
  name: 'floatingReward',
  props: {},
  data: () => ({
    currentLanguage: uiHelper.getLanguage().toLowerCase(),
    i18n,
    showRewardPanel: false,
    active: false,
    pagesToHide: [ROUTE_NAME.REGISTER, ROUTE_NAME.FUNDS]
  }),
  created() {},
  methods: {
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: { lang: this.$route.params.lang }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: { lang: this.$route.params.lang }
        })
      }
    },
    // Hover opens on enter and closes on leave (unless pinned by a click).
    // It used to toggle, so leaving after closing with × re-opened the panel.
    hoverRewardPanel(open) {
      if (!this.active) this.showRewardPanel = open
    },
    setShowRewardPanel() {
      if (!this.active && this.showRewardPanel) {
        this.active = true
        this.showRewardPanel = true
      } else {
        this.active = !this.active
        this.showRewardPanel = !this.showRewardPanel
      }
    },
    hideShowRewardPanel() {
      this.active = false
      this.showRewardPanel = false
    },
    navigateToCoinPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.FUNDS,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    navigateToVoucherPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    navigateToDailyCheckIn() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.REWARDS,
        params: {
          lang: this.$route.params.lang
        }
      })
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
// ---------- Shared NG88 floating tab + panel (also used by FloatingContactUs) ----------
.ng-float {
  position: fixed;
  display: flex;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  outline: none;
  font-family: var(--ng-font);
}

.ng-float-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 8px;
  border: 0;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(18, 23, 52, 0.25);
  transition: padding 0.2s ease-out, box-shadow 0.2s ease-out;

  &:hover,
  &:focus-visible {
    box-shadow: 0 8px 22px rgba(18, 23, 52, 0.35);
  }

  &:focus-visible {
    outline: 2px solid var(--ng-yellow);
    outline-offset: 2px;
  }

  .ng-float-tab-label {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-family: var(--ng-font-bold);
    font-size: 13px;
    letter-spacing: 1px;
    text-transform: uppercase;
    white-space: nowrap;
  }
}

.ng-float-tab--rewards {
  border-radius: 0 14px 14px 0;
  background: var(--ng-gradient-cta);
  color: var(--ng-navy);

  &:hover {
    padding-left: 12px;
  }
}

.ng-float-panel {
  width: 280px;
  margin: 0 12px;
  padding: 14px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 20px 40px rgba(18, 23, 52, 0.3);
  animation: ngFloatIn 0.22s ease-out;

  .ng-float-panel-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
  }

  .ng-float-panel-title {
    flex: 1 1 auto;
    font-family: var(--ng-font-bold);
    font-size: 15px;
    line-height: 1.3;
    color: var(--ng-text);
  }

  .ng-float-close {
    flex: none;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 999px;
    background: #f1f2f8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: #e4e6f2;
    }
  }
}

.ng-float-tiles {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ng-float-tile {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(18, 23, 52, 0.12);
  transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;

  &:hover,
  &:focus-visible {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(18, 23, 52, 0.22);
  }

  .reward-image {
    display: block;
    width: 100%;
    height: auto;
  }
}

@keyframes ngFloatIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

// ---------- Rewards placement ----------
.floating-left.ng-float {
  left: 0;
}

// Mobile: round button bottom-left (mirrors the chat button bottom-right) instead of an edge strip over content
@media (max-width: 959px) {
  .floating-left.ng-float {
    top: auto;
    left: 14px;
    bottom: 84px;
    transform: none;
    flex-direction: column-reverse;
    align-items: flex-start;

    .ng-float-tab--rewards {
      width: 52px;
      height: 52px;
      padding: 0;
      border-radius: 999px;
      justify-content: center;
      border: 3px solid #ffffff;

      &:hover {
        padding: 0;
      }

      .ng-float-tab-label {
        display: none;
      }
    }

    .ng-float-panel {
      position: fixed;
      left: 12px;
      right: 12px;
      bottom: 148px;
      width: auto;
      max-width: 360px;
      margin: 0 auto 0 0;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .ng-float-panel {
    animation: none;
  }

  .ng-float-tab,
  .ng-float-tile {
    transition: none;
  }
}
</style>
